export default "__VITE_ASSET__Dana9kWS__"